namespace GeniuzPOS.ReportMasterData {
    export class Report_1104Columns {
        static columnsKey = 'ReportMasterData.Report_1104';
    }
}
